import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DegreeSelectComponent} from './components/degree-select/degree-select.component';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePickerComponent} from './components/date-picker/date-picker.component';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NumberInputComponent} from './components/number-input/number-input.component';
import {AutocompleteComponent} from './components/autocomplete/autocomplete.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CommonInputComponent} from './components/common-input/common-input.component';
import {MultilineInputComponent} from './components/multiline-input/multiline-input.component';
import {MoveInArrayArrowsComponent} from './components/move-in-array-arrows/move-in-array-arrows.component';
import {MatIconModule} from '@angular/material/icon';
import {UpdateArrayButtonsComponent} from './components/update-array-buttons/update-array-buttons.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormElementsService} from './services/form-elements.service';
import {TranslateModule} from '@ngx-translate/core';
import {AutocompleteSelectComponent} from './components/autocomplete-select/autocomplete-select.component';
import {AutocompleteStringSelectComponent} from './components/autocomplete-string-select/autocomplete-string-select.component';
import {MultilineSelectComponent} from './components/multiline-select/multiline-select.component';
import {CommonSelectComponent} from './components/common-select/common-select.component';
import {RequireObjectDirectiveModule} from '../../directives/require-object-directive/require-object-directive.module';
import {RequireStringMatchModule} from '../../directives/require-string-match/require-string-match.module';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from "@angular/material/button-toggle";


@NgModule({
  declarations: [
    DegreeSelectComponent,
    DatePickerComponent,
    NumberInputComponent,
    AutocompleteComponent,
    CommonInputComponent,
    MultilineInputComponent,
    MoveInArrayArrowsComponent,
    UpdateArrayButtonsComponent,
    AutocompleteSelectComponent,
    AutocompleteStringSelectComponent,
    MultilineSelectComponent,
    CommonSelectComponent
  ],
  exports: [
    DegreeSelectComponent,
    DatePickerComponent,
    NumberInputComponent,
    AutocompleteComponent,
    MultilineInputComponent,
    MoveInArrayArrowsComponent,
    UpdateArrayButtonsComponent,
    AutocompleteSelectComponent,
    AutocompleteStringSelectComponent,
    MultilineSelectComponent,
    CommonSelectComponent
  ],
    imports: [
        CommonModule,
        MatSelectModule,
        FormsModule,
        MatInputModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTooltipModule,
        ReactiveFormsModule,
        TranslateModule,
        RequireObjectDirectiveModule,
        RequireStringMatchModule,
        MatButtonModule,
        MatButtonToggleModule,
    ],
  providers: [
    FormElementsService
  ]
})
export class FormElementsModule {
}
